<div mat-dialog-title class="banner__title">Important Information</div>
<div mat-dialog-content class="banner__content">
  <p>
    You are using a news analytics application powered by Artificial
    Intelligence, which may sometimes provide incorrect or unexpected results.
    Please always verify the results to ensure that your work product is
    accurate and appropriate.
  </p>
</div>
<div mat-dialog-actions class="banner__actions">
  <button mat-button class="contact-button" (click)="onContactUsClick()">
    Contact Us
  </button>
  <button mat-button class="active-button" (click)="onUnderstand()">
    Agree and close
  </button>
</div>
